// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"8f4691383828da5251e8","293":"d2172579be1ba900438e","518":"9b8af3a7ff25bd5b1d7c","779":"d0aef23fed0ab0c470b3"}[chunkId] + ".js";
};